<template>
  <div v-show="auth.authenticated">
    <nav class="navbar navbar-default" role="navigation">
      <div>
        <div class="navbar-header">

          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <!-- Left Side Of Navbar -->
          <ul class="nav navbar-nav navbar-right" v-if="auth.authenticated">

            <li><router-link class="navbar-brand" to="/category">פרויקטים</router-link></li>
          </ul>
          <!-- Right Side Of Navbar -->
          <ul class="nav navbar-nav" v-if="auth.authenticated">

            <li class="dropdown rtl" style="float:left;">

              <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                <span class="caret"></span>
              </a>

              <ul class="dropdown-menu" role="menu">
                <li><a href="javascript:void(0)" v-on:click="signout">התנתק</a></li>
              </ul>

            </li>
            <router-link class="navbar-brand rtl" to="/">ניהול OCD</router-link>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import { auth } from "@/main";

export default {
  data() {
    return {
      auth
    };
  },
  methods: {
    signout() {
      auth.signout("Logged out", "success");
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      auth.check();
    });
  }
};
</script>

<style scoped>
/* navbar */
.navbar-default {
  background-color: #2a7eb4!important;
  border-color: #e7e7e7!important;
}
/* title */
.navbar-default .navbar-brand {
  color: #fff!important;
  padding: 15px!important;
  font-size: 18px!important;
}

.navbar-default .navbar-brand:hover,
.navbar-default .navbar-brand:focus {
  color: #ddd!important;
}
/* link */
.navbar-default .navbar-nav > li > a {
  color: #fff!important;
}
.navbar-default .navbar-nav > li > a:hover,
.navbar-default .navbar-nav > li > a:focus {
  color: #ddd!important;
}
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:hover,
.navbar-default .navbar-nav > .active > a:focus {
  color: #555!important;
  background-color: #e7e7e7!important;
}
.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus {
  color: #555!important;
  background-color: #a5b8c9!important;
}
/* caret */
.navbar-default .navbar-nav > .dropdown > a .caret {
  border-top-color: #fff!important;
  border-bottom-color: #fff!important;
}
.navbar-default .navbar-nav > .dropdown > a:hover .caret,
.navbar-default .navbar-nav > .dropdown > a:focus .caret {
  border-top-color: #ddd!important;
  border-bottom-color: #ddd!important;
}
.navbar-default .navbar-nav > .open > a .caret,
.navbar-default .navbar-nav > .open > a:hover .caret,
.navbar-default .navbar-nav > .open > a:focus .caret {
  border-top-color: #555!important;
  border-bottom-color: #555!important;
}
/* mobile version */
.navbar-default .navbar-toggle {
  border-color: #ddd!important;
}
.navbar-default .navbar-toggle:hover,
.navbar-default .navbar-toggle:focus {
  background-color: #ddd!important;
}
.navbar-default .navbar-toggle .icon-bar {
  background-color: #fff!important;
}
@media (max-width: 767px) {
  .navbar-default .navbar-nav .open .dropdown-menu > li > a {
    color: #fff!important;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #ddd!important;
  }
}
li {
  float: right!important;
}
</style>



// WEBPACK FOOTER //
// Header.vue?ba914c76